/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'react',
	'react-dom',
	'jquery',
	'../../lib/@waca/baglass/js/baglass/app/plugins/MenuActionInterface',
	'../views/CreateAssetMenu'
], (React, ReactDOM, $, MenuActionInterface, CreateAssetMenu) => {

	const NEW_MENU_COLLECTION_ID = 'com.ibm.bi.glass.global.menus';
	const NEW_MENU_ID = 'com.ibm.bi.glass.common.createMenu';
	const NAV_MENU_EVENTS = 'navmenu:slideout:open';

	class NavMenuActionController extends MenuActionInterface {

		onSelectItem(context) {
			const key = this._getPluginKey(context.target.itemId);
			const Glass = context.glassContext;
			if ( key === 'gohome' ) {
				return Glass.openAppView();
			} else {
				Glass.getCoreSvc('.Logger').warn(`NavMenuActionController: Unknown Plugin: ${context.target.itemId}`);
			}
		}

		onRenderItem(context) {
			const key = this._getPluginKey(context.target.itemId);
			const Glass = context.glassContext;
			if ( key === 'gohome' ) {
				const currentPerspective = Glass.getCurrentPerspective();
				return Glass.getHomePageObject().then(hpo => {
					if ( hpo.perspective === currentPerspective ) {
						context.target.activeObject.addClass('isActive');
					}
				});
			} else if ( key === 'newAsset' ) {
				this._renderNewMenu(Glass, context);
			}
		}

		_getPluginKey(itemId) {
			const idTokens = itemId.split('.');
			return idTokens[idTokens.length - 1];
		}

		_renderNewMenu(Glass, context) {
			const $el = context.target.activeObject;
			$el.addClass('link'); // Add the pretty blue color UX wants...

			// This can be slow to load actionHandles... so start it early
			this._newItemsPromise = Glass.findCollection(NEW_MENU_COLLECTION_ID).then(collection => {
				if ( collection && collection.length > 0 ) {
					return collection.find(el => el.id === NEW_MENU_ID);
				}
			}).then((menu) => {
				if ( menu && menu.items && menu.items.length > 0 ) {
					if ( !$el._newMenu ) {
						const $menuParent = $el.parents('.popover.ba-carbon-nav-menu');
						const $container = $('<div class="ba-portal-create-menu-container"/>');
						$container.appendTo($menuParent);
						$el._newMenu = ReactDOM.render(
							<CreateAssetMenu
								Glass={Glass}
								menuSpec={menu}
								menuId={NEW_MENU_ID}
								onHidden={() => { $el.focus(); }}
							/>,
							$container[0]);

						Glass.getCoreSvc('.Events').on(NAV_MENU_EVENTS, (payload) => {
							if ( payload.target !== NEW_MENU_ID ) {
								$el.removeClass('isActive');
								$el._newMenu.closeMenu();
							}
						});

						// Block default menu event handling so it doesn't dismiss
						$el.on('clicktap', this._toggleNewMenu.bind(this, Glass, $el));
						$el.on('keypress keyup', evt => { evt.preventDefault() && evt.stopPropagation(); });
						$el.on('keyup', evt => {
							const keycode = evt.keyCode || evt.which;
							if ( keycode === 13 || keycode === 32 ) {
								this._toggleNewMenu(Glass, $el, evt, true /* setFocus */ );
							}
						});
					}
				} else {
					$el.hide();
				}
			});
		}

		_toggleNewMenu(Glass, $el, evt, setFocus = false) {
			evt.stopPropagation();
			evt.preventDefault();
			$el.blur();
			this._newItemsPromise.then(() => {
				Glass.getCoreSvc('.Events').trigger(NAV_MENU_EVENTS, { target: NEW_MENU_ID });
				setTimeout(() => {
					$el.toggleClass('isActive');
					$el._newMenu.toggleState(setFocus);
				}, 0);
			});
		}
	}

	return NavMenuActionController;
});